import { getMsalInstanceShared } from '@/authConfig';
import { InteractionRequiredAuthError } from '@azure/msal-browser';

import { scopeUri } from './msalScopeUri';

export async function getAccessToken(): Promise<string | null> {
  const msalInstanceShared = getMsalInstanceShared();

  const account =
    msalInstanceShared.getActiveAccount() ||
    msalInstanceShared.getAllAccounts()[0];
  if (!account) {
    // eslint-disable-next-line no-console
    console.log('No msal account found.');
    return null;
  }

  const request = {
    scopes: [scopeUri],
    account,
  };

  try {
    const response = await msalInstanceShared.acquireTokenSilent(request);
    return response.accessToken;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.info(
      'Silent token acquisition failed, trying redirect/login',
      error,
    );

    if (error instanceof InteractionRequiredAuthError) {
      // fallback to interactive
      await msalInstanceShared.acquireTokenRedirect(request); // or acquireTokenPopup
    } else {
      // eslint-disable-next-line no-console
      console.error('Failed to get token silently:', error);
    }
    return null;
  }
}
